/**
 *  An iframe that sandboxes wix-dealer ads rendered by our da-wix-dealer app
 *  the app communicates with this component using the postMessage api, telling
 *  it whether an ad was loaded ('ad-filled') or none is available ('ad-empty')
 */ import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useCallback, useState, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './DealerAdIframe.scss';
const IFRAME_TITLE = 'DealerAdIframe';
const DEALER_RUNNING_LOCALLY = false;
const ADS_ENDPOINT = DEALER_RUNNING_LOCALLY ? 'http://localhost:5000/_nsfgfb' : 'https://www.deviantart.com/_nsfgfb';
const WIX_DEALER_MESSAGE_TYPE = 'dealerAd';
// this next id can be used to test the system and should always be available
export const TEST_REALESTATEID = 'd4c58bed-9276-439f-b040-36472ccfba3c';
const DealerAdIframe = (props)=>{
    const { realEstateId , showAndCollapse , className , neverCollapse , fillBlock  } = props;
    const { useridUuid: userGuid , biClientId , biClientIdSigned  } = useContext(SessionContext);
    const noDealerAds = useFlag('no_dealer_ads'); // do not show ads at all, useful for storybook and such
    const fakeAds = useFlag('wireframe_ads'); // show a placeholder instead of the iframe, useful for debugging
    const [collapsed, setCollapsed] = useState(false);
    const handler = useCallback((data)=>{
        switch(data.command){
            case 'ad-empty':
            case 'ad-filled':
                if (fakeAds) {
                    setCollapsed(false);
                } else if (!neverCollapse) {
                    setCollapsed(showAndCollapse ? data.command === 'ad-empty' : data.command !== 'ad-filled');
                }
                break;
            default:
                break;
        }
    }, [
        fakeAds,
        neverCollapse,
        showAndCollapse
    ]);
    useWixDealerListener(realEstateId, handler);
    // When we have display ads, don't use dealer
    if (noDealerAds) {
        return null;
    }
    const classNames = classnames(s['root'], collapsed && s['collapsed'], fillBlock && s['fill-block'], className);
    const paramsToSend = new URLSearchParams(Object.entries({
        realEstateId,
        userGuid,
        biClientId,
        biClientIdSigned,
        newApi: 2
    }).filter((e)=>e[1]));
    const iframeProps = {
        loading: 'lazy',
        scrolling: 'no',
        frameBorder: '0',
        style: {
            border: '0px'
        }
    };
    if (fakeAds) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                background: 'lightskyblue',
                overflow: 'auto'
            },
            className: classNames
        }, realEstateId);
    }
    return /*#__PURE__*/ React.createElement("iframe", _extends({
        className: classNames
    }, iframeProps, {
        title: IFRAME_TITLE,
        src: `${ADS_ENDPOINT}/?${paramsToSend}`
    }));
};
DealerAdIframe.displayName = 'DealerAdIframe';
// ------------
/** Listen to 'message' events from an iframe containing the da-wix-dealer
 *  app and filtering by a realEstateId */ function useWixDealerListener(realEstateId, handler) {
    useEffect(()=>{
        const messageHandler = (event)=>{
            if (event.data && event.data.type === WIX_DEALER_MESSAGE_TYPE && event.data.realEstateId === realEstateId) {
                handler(event.data);
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        realEstateId,
        handler
    ]);
}
// never, ever re-render the iframe
export default /*#__PURE__*/ React.memo(DealerAdIframe, ()=>true);
